import { motion } from "framer-motion";
import BannerImg from "../../assets/image_4.png";
import Img from "../../assets/6.svg";

export default function TuberPartners() {

    return (
        <section className="px-4 mt-10 md:mt-28 mb-12 md:mb-36">
            <div className="max-w-7xl w-full mx-auto grid grid-cols-1 md:grid-cols-2 gap-5">
                {/* Left Section */}
                <motion.div
                    className="w-full flex flex-col justify-center"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    viewport={{ once: true }}
                >
                    <span className="text-primary block font-bold mb-3 text-sm md:text-lg uppercase">Tuber Partners</span>

                    <h2 className="text-2xl md:text-4xl max-w-[550px] capitalize font-bold mb-2 md:mb-6 text-headings">
                        A Service we trust
                    </h2>

                    <p className="text-light_black max-w-[500px] text-sm md:text-lg">
                        As a tradesman, I used to spend hours running back and forth to the store. But
                        with Tuber, I ordered what I needed from Mitre10, and within two hours, the materials were
                        on-site. I didn’t have to leave my job, and Tuber’s ute handled the delivery perfectly. It’s a
                        game-changer for keeping projects on track.
                    </p>
                </motion.div>

                {/* Right Section - Video */}
                <motion.div
                    className="w-full relative h-[220px] md:h-[450px] bg-gray-100"
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                    viewport={{ once: true }}
                >
                    <img
                        src={BannerImg}
                        alt="Image 4"
                        className="object-cover w-full h-full rounded-xl"
                    />
                </motion.div>
            </div>

            <div className="flex justify-center items-center">
                <img src={Img} alt="img" loading="lazy" className="h-auto md:h-[700px]" />
            </div>
        </section>
    );
}
